export default __webpack_public_path__ + "static/media/logo-3.4f892859.png";